import React from 'react'
import { Typography } from '@mui/material'
import { date, format } from '@e3dc-react/shell/Libs/date'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS } from 'src/Libs/installations/constants'

interface IbnDeadlineProps {
  ibnDeadlineAt: string | undefined
}

/**
 * display the installation statement deadline for a given installation.
 */
const IbnDeadline: React.FC<IbnDeadlineProps> = ({ ibnDeadlineAt }) => {
  const { t } = useCustomTranslation()
  if (!ibnDeadlineAt) return <Typography>--</Typography>

  const ibnDeadlineDate = new Date(ibnDeadlineAt)
  const now = new Date()

  /* user will see warning when deadline is between now and threshold date */
  const thresholdDate = date.addMonths(now, INSTALLATION_STATEMENT_DEADLINE_THRESHOLD_MONTHS)

  const isDeadlineOver = date.isBefore(ibnDeadlineDate, now)

  const isDeadlineNear = date.isBefore(ibnDeadlineDate, thresholdDate)

  if (isDeadlineOver) {
    return (
      <Typography variant="body2" color="text.primary">
        {t('installation-statement.overviewTable.deadline-expired')}
      </Typography>
    )
  }

  if (isDeadlineNear) {
    return (
      <Typography variant="h5" color="warning.main">
        {format(new Date(ibnDeadlineAt), t('common.format.date-fns-date'))}
      </Typography>
    )
  }

  return (
    <Typography variant="body2" color="text.primary">
      {format(new Date(ibnDeadlineAt), t('common.format.date-fns-date'))}
    </Typography>
  )
}

export default IbnDeadline
